import { render, staticRenderFns } from "./EsgPartnerEmissionShare.vue?vue&type=template&id=24789980"
import script from "./EsgPartnerEmissionShare.vue?vue&type=script&lang=js"
export * from "./EsgPartnerEmissionShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports